import { defineStore, acceptHMRUpdate } from "pinia";
import { brogglBack } from "../axios.js";
import router from "../router/index.js";
import { useFormStore } from "./form.js"

export const useUserStore = defineStore("user", {
  state: () => ({
    error: null,
    resetPasswordError: null,
    params: {
      email: "",
      password: "",
    },
    paramsReset: {
      password: "",
      token: "",
      email: ""
    },
    token: "",
    user: {},
    passwordConfirmation: "",
    information: "",
    clients: [],
    dashboard: {},
    sumARR: 0,
    name: "",
    configuration: "",
    timerMode: "Normal",
    userEntries: {},
    totalItems: 0,
    currentPage: 1,
    currentPageSaver: 1,
    isUserAdmin: false,
    newUser: {
      name: "",
      email: "",
      password: "",
      slackUsername: "",
      role: "",
      country: "",
      pod: "",
      isLead: false,
      username: "",
    },
    userOnboardingSucces: false,
    onboardDataSended: false,
    submittingData: false,
    submittingDataOffboard: false,
    emailToOffboard: "",
    userOffboardingSucces: false,
    offboardDataSended: false,
    paramsStartPasswordReset: {
      mail: "",
    },
    informationPasswordReset: "",
    buttonDisabledPasswordReset: false,
    testIdToSearch: "",
    userEntriesIsLoaded: false
  }),
  getters: {
    getError: (state) => {
      return state.error;
    },
    getResetPasswordError: (state) => {
      return state.resetPasswordError;
    },
    getParams: (state) => {
      return state.params;
    },
    getParamsReset: (state) => {
      return state.paramsReset;
    },
    getToken: (state) => {
      return state.token;
    },
    getUser: (state) => {
      return state.user;
    },
    getPasswordConfirmation: (state) => {
      return state.passwordConfirmation;
    },
    getInformation: (state) => {
      return state.information;
    },
    getClients: (state) => {
      return state.clients;
    },
    getDashboard: (state) => {
      return state.dashboard;
    },
    getSumARR: (state) => {
      return state.sumARR;
    },
    getName: (state) => {
      return state.name;
    },
    getConfiguration: (state) => {
      return state.configuration;
    },
    getTimerMode: (state) => {
      return state.timerMode;
    },
    getUserEntries: (state) => {
      return state.userEntries;
    },
    getIsUserAdmin: (state) => {
      return state.isUserAdmin;
    },
    getNewUser: (state) => {
      return state.newUser;
    },
    getUserOnboardingSucces: (state) => {
      return state.userOnboardingSucces;
    },
    getOnboardDataSended: (state) => {
      return state.onboardDataSended;
    },
    getSubmittingData: (state) => {
      return state.submittingData;
    },
    getSubmittingDataOffboard: (state) => {
      return state.submittingDataOffboard;
    },
    getEmailToOffboard: (state) => {
      return state.emailToOffboard;
    },
    getUserOffboardingSucces: (state) => {
      return state.userOffboardingSucces;
    },
    getOffboardDataSended: (state) => {
      return state.offboardDataSended;
    },
    getTestIdToSearch: (state) => {
      return state.testIdToSearch;
    },
    getTotalItems: (state) => {
      return state.totalItems
    },
    getUserEntriesIsLoaded: (state) => {
      return state.userEntriesIsLoaded
    }
  },
  actions: {
    async signIn() {
      try {
        const res = await brogglBack.post("/user/login", this.params);
        this.token = res.data.data.token;
        this.user = res.data.data.user;
        this.error = null;
        this.params = {
          email: "",
          password: "",
        };
        window.$cookies.set("jwt", this.token, "8h");
        window.$cookies.set("user", this.user, "8h");
        window.$cookies.set("_isLead", this.user.IsLead, "8h");
        this.router.push({ path: "/home" });
      } catch (err) {
        console.log(err);
        this.error = err;
      }
    },
    async sendPasswordRequest() {
      try {
        const res = await brogglBack.post("/user/start-password-reset", {
          email: this.paramsStartPasswordReset.mail,
        });
        this.buttonDisabledPasswordReset = true;
        this.informationPasswordReset =
          "Go check your emails for further instructions";
        router.push({ path: "/reset-password" });
      } catch (err) {
        console.log(err);
        this.information =
          "Something went wrong, try again and if it still does not work check with Broggl's team";
      }
    },
    checkIfAlreadyLogged() {
      if (
        window.$cookies.get("jwt") !== null &&
        window.$cookies.get("jwt") !== undefined
      ) {
        this.router.push({ path: "/home" });
      } else {
        console.log("The token has expired");
      }
    },
    async resetPassword() {
      try {
        const res = await brogglBack.post(
          "/user/password-reset",
          this.paramsReset,
        );
        // console.log(res)
        if (res.status === 200) {
          this.information = res.message;
        } else {
          this.resetPasswordError = res.message;
        }
        this.paramsReset = {
          password: "",
          token: "",
          email: ""
        };
        this.router.push({ path: "/login" });
      } catch (err) {
        console.log(err);
        this.resetPasswordError = err;
      }
    },
    async fecthFavorites() {
      try {
        const res = await brogglBack.get("/favorites?userId=" + this.user.ID, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });
        this.clients = res.data.data;
        let sum = 0;
        let keys = Object.keys(res.data.data);
        for (const element of keys) {
          sum += parseFloat(res.data.data[element].Arr);
        }
        this.sumARR = sum;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchUserDashboard() {
      try {
        const res = await brogglBack.get("/user/dashboard", {
          params: {
            userId: this.user.ID,
          },
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });
        this.dashboard = res.data.data;
        this.name = this.dashboard.name;
        this.configuration = this.dashboard.configuration;
        this.configLayout();
      } catch (err) {
        console.log(err);
      }
    },
    configLayout() {
      if (this.configuration === "TE") {
        this.timerMode = "Timer";
      } else if (this.configuration === "CSM") {
        this.timerMode = "Normal";
      } else {
        this.timerMode = "Normal";
      }
    },
    async fetchUserEntries() {
      const formStore = useUserStore()
      this.userEntriesIsLoaded = false
      try {
        if (this.testIdToSearch !== "") {
          this.currentPageSaver = this.currentPage
          this.currentPage = 1
          let res = await brogglBack.get(
            "/entries/paginate-user/" + this.user.ID,
            {
              params: { page: this.currentPage, testId: this.testIdToSearch },
              headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
            },
          );
          let entriesBack = res.data.data.entries;
          let sortedResult = {};
          const sortedKeys = Object.keys(entriesBack).sort((a, b) => {
            const dateA = new Date(a);
            const dateB = new Date(b);
            return dateB - dateA;
          });
          sortedKeys.forEach((key) => {
            sortedResult[key] = entriesBack[key];
          });
          this.userEntries = sortedResult;
          this.totalItems = res.data.data.nbrOfEntries;
        } else {
          if (this.currentPageSaver !== 1) {
            this.currentPage = this.currentPageSaver
            this.currentPageSaver = 1
          }
          let res = await brogglBack.get(
            "/entries/paginate-user/" + this.user.ID,
            {
              params: { page: this.currentPage, testId: this.testIdToSearch },
              headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
            },
          );
          let sortedKeys = Object.keys(res.data.data).sort((a, b) => {
            const dateA = new Date(a);
            const dateB = new Date(b);
            return dateB - dateA;
          });
          let sortedResult = {};
          sortedKeys.forEach((key) => {
            sortedResult[key] = res.data.data[key];
          });
          this.userEntries = sortedResult;
          // await this.fetchNumberOfEntries();
          const resTotalEntries = await brogglBack.get(
            "/entries/number-of-entries-user/" + this.user.ID,
            {
              headers: {
                Authorization: `Bearer ${this.token}`,
              },
            },
          );
          this.totalItems = resTotalEntries.data.data;
        }
        this.userEntriesIsLoaded = true
      } catch (err) {
        console.log(err);
      }
    },
    async fetchNumberOfEntries() {
      try {
        const res = await brogglBack.get(
          "/entries/number-of-entries-user/" + this.user.ID,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          },
        );
        this.totalItems = res.data.data;
      } catch (err) {
        console.log(err);
      }
    },
    isClientInFavoritesList(clientId) {
      let result = false;
      Object.keys(this.clients).forEach((client) => {
        const currClient = this.clients[client];
        if (clientId === currClient.clientID) {
          result = true;
        }
      });
      return result;
    },
    async homePageWrapper() {
      this.loadUser();
      this.loadToken();
      await this.fecthFavorites();
      await this.fetchUserDashboard();
      //await this.fetchNumberOfEntries();
      await this.fetchUserEntries(1);
    },
    loadUser() {
      if (Object.keys(this.user).length === 0) {
        if (
          window.$cookies.get("user") !== null &&
          window.$cookies.get("user") !== undefined
        ) {
          this.user = window.$cookies.get("user");
        } else {
          this.router.push({ path: "/login" });
        }
      }
    },
    loadToken() {
      if (this.token === "") {
        if (
          window.$cookies.get("jwt") !== null &&
          window.$cookies.get("jwt") !== undefined
        ) {
          this.token = window.$cookies.get("jwt");
        } else {
          this.router.push({ path: "/login" });
        }
      }
    },
    getUserId() {
      this.loadUser();
      return this.user.ID;
    },
    getUserName() {
      this.loadUser();
      return this.user.Name;
    },
    switchMode() {
      if (this.timerMode === "Timer") {
        this.timerMode = "Normal";
      } else if (this.timerMode === "Normal") {
        this.timerMode = "Timer";
      }
    },
    checkIfUserIsAdmin() {
      this.loadUser();
      if (
        this.user.Email === "pauline@abtasty.com" ||
        this.user.Email === "julien.hue@abtasty.com" ||
        this.user.Email === "leon@abtasty.com" ||
        (this.user.Role === "Other" && this.user.IsLead === true)
      ) {
        this.isUserAdmin = true;
      }
    },
    async onboardUser() {
      try {
        this.submittingData = true;
        this.onboardDataSended = true;
        this.loadToken();
        const res = await brogglBack.post(
          "/user/onboard",
          {
            name: this.newUser.name,
            email: this.newUser.email,
            password: this.newUser.password,
            slackUsername: this.newUser.slackUsername,
            role: this.newUser.role,
            country: this.newUser.country,
            pod: this.newUser.pod,
            isLead: this.newUser.isLead,
            username: this.newUser.name.replace(/\s+/g, "."),
          },
          { headers: { Authorization: "Bearer " + this.token } },
        );
        this.userOnboardingSucces = res.data.data;
        this.newUser = {
          name: "",
          email: "",
          password: "",
          slackUsername: "",
          role: "",
          country: "",
          pod: "",
          isLead: false,
          username: "",
        };
        this.submittingData = false;
      } catch (err) {
        this.submittingData = false;
        this.userOnboardingSucces = false;
        console.log(err);
      }
    },
    async offboardUser() {
      try {
        this.submittingDataOffboard = true;
        this.offboardDataSended = true;
        this.loadToken();
        const res = await brogglBack.post(
          "/user/offboard",
          {
            email: this.emailToOffboard,
          },
          { headers: { Authorization: "Bearer " + this.token } },
        );
        this.userOffboardingSucces = res.data.data;
        this.emailToOffboard = "";
        this.submittingDataOffboard = false;
      } catch (err) {
        this.submittingDataOffboard = false;
        this.userOffboardingSucces = res.data.data;
        console.log(err);
      }
    },
    checkIfUserIsKam() {
      this.loadUser();
      if (this.user.Role === "KAM") {
        return true;
      } else {
        return false;
      }
    },
    checkIfUserIsTeamLead() {
      this.loadUser();
      return this.user.sLead;
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot));
}
